export default {
    position: {
        backToDashboard: 'Natrag na nadzornu ploču',
        loadError: 'Nije moguće učitati poziciju za ugovor',
        tryAgain: 'Pokušajte ponovno',
        header: 'Prikaz pozicije — {name} · {country} · {side} · {product}',
        deliveryLine: 'Isporuka: {start} → {end} · {mwh} doprinosi ovaj ugovor',
        mergeMeta: 'Zadnje spajanje: {lastRun} · {days} dana · {buckets} intervala',
        noSnapshotTitle: 'Još nema snimke pozicije',
        noSnapshotBody:
            'Spajanje za {start}–{end} još nije pokrenuto. Nakon spajanja, doprinos ovog ugovora pojavit će se ovdje.',
        prevDayAria: 'Prethodni dan (Alt+←)',
        nextDayAria: 'Sljedeći dan (Alt+→)',
        show: 'Prikaži:',
        forecastBaseline: 'Osnovna prognoza',
        thisContract: 'Ovaj ugovor',
        allFutures: 'Svi terminski poslovi',
        zeroContribution:
            'Ovaj ugovor nema isporuku na dan {day} (izvan razdoblja isporuke ili nula alokacije).',
        footerSummary:
            'Ovaj dan · prognoza {forecast} MWh · terminski {futures} MWh · konačno {final} MWh · smjer {direction}',
    },
}
